// extracted by mini-css-extract-plugin
module.exports = {"activities-list":"KanbanCollaborationSidebar_activities-list__31_ds","activities-list-item":"KanbanCollaborationSidebar_activities-list-item__1jxr-"};